var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2028_916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C2.90715 0 0 2.9074 0 6.5C0 10.0928 2.9074 13 6.5 13C10.0928 13 13 10.0926 13 6.5C13 2.90715 10.0926 0 6.5 0ZM6.5 11.9844C3.46854 11.9844 1.01562 9.53126 1.01562 6.5C1.01562 3.46854 3.46874 1.01562 6.5 1.01562C9.53146 1.01563 11.9844 3.46874 11.9844 6.5C11.9844 9.53146 9.53123 11.9844 6.5 11.9844Z",
    fill: "#8477AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.44238C6.21954 5.44238 5.99219 5.66973 5.99219 5.9502V9.22033C5.99219 9.50079 6.21954 9.72814 6.5 9.72814C6.78046 9.72814 7.00781 9.50077 7.00781 9.2203V5.9502C7.00781 5.66973 6.78046 5.44238 6.5 5.44238Z",
    fill: "#8477AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 4.82031C6.87862 4.82031 7.18555 4.51338 7.18555 4.13477C7.18555 3.75615 6.87862 3.44922 6.5 3.44922C6.12138 3.44922 5.81445 3.75615 5.81445 4.13477C5.81445 4.51338 6.12138 4.82031 6.5 4.82031Z",
    fill: "#8477AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2028_916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.885a6fa5a69bbaf5e26c9bd41d1bc29e.svg";
export { ForwardRef as ReactComponent };